import {
    getInvoices,
    getInvoiceById,
    generateInvoice,
    editInvoice,
    deleteInvoice,
    getInvoiceForGenerate,
    getInvoiceForGenerateTotals,
    uploadInvoiceDocument,
    editInvoiceDocument,
    getInvoiceDocument,
    deleteInvoiceDocument,
    getInvoiceTransactions,
    closeInvoice,
    submitInvoices,
    deleteInvoicesBulk,
    deleteOpenInvoice,
    deleteOpenInvoicesBulk,
} from './invoice.action';

export { invoiceReducer } from './invoice.reducer';
export { watchInvoice } from './invoice.saga';

export const invoiceActions = {
    getInvoices,
    getInvoiceById,
    generateInvoice,
    editInvoice,
    deleteInvoice,
    getInvoiceTransactions,
    closeInvoice,

    /**Get Invoices for generate  */
    getInvoiceForGenerate,
    getInvoiceForGenerateTotals,

    /** Submit & Delete */
    submitInvoices,
    deleteInvoicesBulk,
    deleteOpenInvoice,
    deleteOpenInvoicesBulk,

    /** Invoice Documents */
    uploadInvoiceDocument,
    editInvoiceDocument,
    getInvoiceDocument,
    deleteInvoiceDocument,
};
